import React from "react";
import foto from "../../images/Calendario Cigno 20232024.jpg"
import FrecciaIndietro from "../../commons/FrecciaIndietro";
import Space from "../../commons/Space";
import black from "../../images/News/Black_friday.jpg"
import TitoloSezioni from "../../commons/TitoloSezioni";
import "./NewsPagesFoto.css"
import "../../styles/News.css"
import ScrollToTopOnMount from "../../components/ScrollToTopOnMount";
import sanvalentino from "../../images/News/Promozioni San Valentino.jpg"
import carnevale from "../../images/News/Carnevale/IMG_9635-2.jpg"
import SpaceL from "../../commons/SpaceL";
import fototuffo1 from "../../images/News/Carnevale/IMG_9657.jpg";
import fototuffo2 from "../../images/News/Carnevale/IMG_9660.jpg";
import fototuffo3 from "../../images/News/Carnevale/IMG_9665.jpg";
import foto1 from "../../images/News/Carnevale/IMG_9642.jpg";
import foto2 from "../../images/News/Carnevale/IMG_9649.jpg";
import foto3 from "../../images/News/Carnevale/IMG_9671.jpg";
import foto4 from "../../images/News/Carnevale/IMG_9646.jpg";
import foto5 from "../../images/News/Carnevale/IMG_9644-2.jpg";
import fotorun from "../../images/News/Carnevale/PHOTO-2024-02-17-12-35-14.jpg";
import {Link} from "react-router-dom";
import insta from "../../icone/icons8-instagram-48.png";
import facebook from "../../icone/icons8-facebook-48.png";



function CarnevaleNews () {
    return(
        <div className="text-center">
            <ScrollToTopOnMount />
            <FrecciaIndietro indirizzo={"/news"} />
            <p className="text-center" style={{ fontSize: "22px", fontFamily: "Hammersmith One" }}>{"17.02.2024"}</p>
            <TitoloSezioni title={"Festa di carnevale"} />
            <figure className="text-center">
                <blockquote className="blockquote  font-news" style={{padding: "0 1em 1em 1em"}}>
                    <br/>
                    Sabato mattina la nostra piscina si è trasformata in una spiaggia hawaiana
                    <br/>
                    <br/>
                    <div className="m-auto" style={{maxWidth: "30em"}}>
                        <img className="img-fluid" src={carnevale}/>
                    </div>
                    <SpaceL />
                        <br/> I bambini dei corsi di acquaticità e avviamento si sono divertiti con tanti tuffi e giochi d'acqua
                    <SpaceL />

                    <div className="d-flex flex-row container-news" style={{ overflowX: "auto", marginTop: "1em" }}>
                        <img src={foto1} className="img-fluid img-thumbnail news-img" alt="..." />
                        <img src={foto2} className="img-fluid img-thumbnail news-img" alt="..." />
                        <img src={foto3} className="img-fluid img-thumbnail news-img" alt="..." />
                        <img src={foto4} className="img-fluid img-thumbnail news-img" alt="..." />
                        <img src={foto5} className="img-fluid img-thumbnail news-img" alt="..." />
                        <img src={fototuffo1} className="img-fluid img-thumbnail news-img" alt="..." />
                        <img src={fototuffo2} className="img-fluid img-thumbnail news-img" alt="..." />
                        <img src={fototuffo3} className="img-fluid img-thumbnail news-img" alt="..." />
                    </div>

                    <br/> E la festa continua anche nella sala runnering!
                    <br/>
                    <br/>

                    <div className="m-auto" style={{maxWidth: "15em"}}>
                        <img className="img-fluid" src={fotorun}/>
                    </div>
                    <Space />
                    <h3>Scopri di più sui nostri profili social</h3>
                    <p style={{marginTop: "1em"}}>
                        <Link to="https://www.instagram.com/centrosportivoilcigno/?hl=it">
                            <img src={insta}></img>
                        </Link>
                        <Link to="https://www.facebook.com/ilcignosport.it/?locale=it_IT">
                            <img src={facebook}></img>
                        </Link>
                    </p>
                    <br/>

                </blockquote>
            </figure>



            <Space />

        </div>
    )
}
export default CarnevaleNews